import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";

@inject("store")
@observer
export class DetalhamentoSalarioDiferente extends Component {

    static propTypes = {
        informarSalarioDiferente: PropTypes.bool,
        salarioDiferente: PropTypes.number,
        setSalarioDiferente: PropTypes.func,
        toggleInformarSalarioDiferente: PropTypes.func
    };

    constructor(props) {
        super(props);
    }

    render() {
        const salarioMin = this.props.controller.salarioMin;
        const salarioMax = this.props.controller.salarioMax;
        const solicitacaoEtt = this.props.controller.solicitacaoEtt;
        const salarioDiferenteEditavel = this.props.controller.salarioDiferenteEditavel;
        let validacao;
        if(_.get(this.props, "solicitacaoExcecao"))
            validacao = <Validacao id="salarioDiferente" valor={solicitacaoEtt.salarioDiferente} tipo={["isRequired","salarioMin",0]} />
        else
            validacao = <Validacao id="salarioDiferente" valor={solicitacaoEtt.salarioDiferente} tipo={["isRequired","salarioMin",salarioMin,"salarioMax",salarioMax]} />
        const desabilitarValidacao = _.get(this.props, "desabilitarValidacao", false);

        return (
            <div>
                <div>
                    {salarioDiferenteEditavel ? (
                    <FormGroup check className="checkbox-title">
                        <Label check>
                            <Input type="checkbox"
                                   checked={solicitacaoEtt.informarSalarioDiferente}
                                   onChange={() => this.props.controller.toggleInformarSalarioDiferente()}/>{' '}
                            <span>Informar salário diferente</span>
                        </Label>
                    </FormGroup>
                        ) : solicitacaoEtt.salarioDiferente !== null ? <h4>Salário diferente informado</h4> : ""}
                    {(solicitacaoEtt.informarSalarioDiferente || !salarioDiferenteEditavel) &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            {salarioDiferenteEditavel ? (
                                <FormGroup>
                                    <Label>Valor <sup>*</sup></Label>
                                    <NumberFormat allowNegative={false} className="form-control" thousandSeparator="." decimalPrecision={2} decimalSeparator="," prefix={'R$ '} value={solicitacaoEtt.salarioDiferente} onChange={(event, values) => this.props.controller.setSalarioDiferente(values.floatValue)} />
                                    {!desabilitarValidacao && validacao}
                                </FormGroup>
                            )
                                : solicitacaoEtt.salarioDiferente !== null ? (
                                    <FormGroup>
                                        <Label>Valor</Label>
                                        <NumberFormat allowNegative={false} className="form-control" thousandSeparator="." decimalPrecision={2} decimalSeparator="," prefix={'R$ '} value={solicitacaoEtt.salarioDiferente} readOnly />
                                    </FormGroup>
                                ) : ""
                            }

                        </Col>
                    </Row>
                    }
                </div>
            </div>
        )
    }
}